// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AOSController from "./aos_controller"
application.register("aos", AOSController)

import CellphoneModalController from "./cellphone_modal_controller"
application.register("cellphone-modal", CellphoneModalController)

import Compliance__DashboardController from "./compliance/dashboard_controller"
application.register("compliance--dashboard", Compliance__DashboardController)

import CustomerInformationModalController from "./customer_information_modal_controller"
application.register("customer-information-modal", CustomerInformationModalController)

import DebouncedFormSubmitController from "./debounced_form_submit_controller"
application.register("debounced-form-submit", DebouncedFormSubmitController)

import DocxSignersModalController from "./docx_signers_modal_controller"
application.register("docx-signers-modal", DocxSignersModalController)

import EmailChangeRecreateDocumentsHintController from "./email_change_recreate_documents_hint_controller"
application.register("email-change-recreate-documents-hint", EmailChangeRecreateDocumentsHintController)

import DtIntegrationFormController from "./dt_integration_form_controller"
application.register("dt-integration-form", DtIntegrationFormController)

import DtCredentialFormController from "./dt_credential_form_controller"
application.register("dt-credential-form", DtCredentialFormController)

import DtMappingFieldFormController from "./dt_mapping_field_form_controller";
application.register("dt-mapping-field-form", DtMappingFieldFormController);

import DtRecordInfoFormController from "./dt_record_info_form_controller"
application.register("dt-record-info-form", DtRecordInfoFormController)

import DtFetchDtInfoRequestFormController from "./dt_fetch_dt_info_request_form_controller"
application.register("dt-fetch-dt-info-request-form", DtFetchDtInfoRequestFormController)

import GridViewOptionsController from "./grid_view_options_controller"
application.register("grid-view-options", GridViewOptionsController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import PortalCorporateEmailChangeController from "./portal_corporate_email_change_controller"
application.register("portal-corporate-email-change", PortalCorporateEmailChangeController)

import MembershipFormController from "./membership_form_controller"
application.register("membership-form", MembershipFormController)

import PasswordComplexityController from "./password_complexity_controller"
application.register("password-complexity", PasswordComplexityController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import PortalPreviewController from "./portal_preview_controller"
application.register("portal-preview", PortalPreviewController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabNavigationController from "./tab_navigation_controller"
application.register("tab-navigation", TabNavigationController)

import TemplateSelectorController from "./template_selector_controller"
application.register("template-selector", TemplateSelectorController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import WorkflowFormController from "./workflow_form_controller"
application.register("workflow-form", WorkflowFormController)
